// Module
var code = `<breadcrumbs></breadcrumbs>
<gl-header>
  <div class="info__column">
      <span class="info__field" ng-repeat="entry in \$ctrl.header">
        <span class="info__field-label">{{entry.label}}:</span>
        <span class="info__field-value">{{entry.text}}</span>
      </span>
  </div>
</gl-header>
<section class="box">
  <sub-header header="'GL transaction'"></sub-header>
  <form name="createTransactionForm" class="transaction-create-form" novalidate>
    <table class="table table--generate-row-ids transaction-create-form-table"
           ng-if="!\$ctrl.modificationMode || \$ctrl.backdated">
     <tbody>
      <tr ng-if="!\$ctrl.modificationMode">
        <td></td>
        <td>Type:</td>
        <td>
          <select id="transactionType"
                  class="transaction-create-type-select"
                  ng-model="\$ctrl.model.transactionType"
                  ng-change="\$ctrl.transactionTypeChanged(\$ctrl.model.transactionType, '{{\$ctrl.model.transactionType}}')"
                  ng-options="type.value as type.label for type in \$ctrl.glTransactionType">
          </select>
        </td>
      </tr>
      <tr ng-if="!\$ctrl.modificationMode">
        <td></td>
        <td>Mode:</td>
        <td>
          <select ng-options="type.value as type.label for type in \$ctrl.glTransactionInputMode"
                  ng-model="\$ctrl.inputMode"
                  ng-change="\$ctrl.inputModeChanged(\$ctrl.inputMode, '{{\$ctrl.inputMode}}')"
                  required>
          </select>
        </td>
      </tr>
      <tr ng-if="!\$ctrl.modificationMode && \$ctrl.model.transactionType === 'NORMAL' && \$ctrl.inputMode === 'MANUAL'">
        <td></td>
        <td>Use categories:</td>
        <td>
          <select
              ng-model="\$ctrl.useCategories"
              boolean-options
              ng-change="\$ctrl.useCategoriesChanged()"
              required>
          </select>
        </td>
      </tr>
      <validator condition="\$ctrl.model.postingDateValid"></validator>
       <tr ng-if="\$ctrl.backdated">
         <td></td>
         <td>Posting date:</td>
         <td>
           <date ng-required="true"
                 ng-model="\$ctrl.model.backdatedPostingDate"
                 ng-class="{'nx-invalid': !\$ctrl.model.postingDateValid}"
                 ng-change="\$ctrl.validatePostingDate()"
                 min="\$ctrl.minBackdatedPostingDate"
                 max="\$ctrl.maxBackdatedPostingDate">
           </date>
         </td>
       </tr>
       <tr ng-if="!\$ctrl.modificationMode && \$ctrl.model.transactionType === 'NORMAL' && \$ctrl.useCategories">
         <td></td>
         <td>Category:</td>
         <td>
           <gl-category-select
               action-type="'MANUAL_TICKET'"
               single-accounts-only="false"
               ng-model="\$ctrl.category"
               is-selectize="true"
               ng-change="\$ctrl.categoryChanged()"
           >
           </gl-category-select>
         </td>
       </tr>
      <tr ng-if="!\$ctrl.modificationMode && \$ctrl.inputMode === 'BATCH'">
        <td></td>
        <td>File:</td>
        <td>
          <file-upload ng-model="\$ctrl.contentFile"
                       required
                       validate-uploaded
                       max-files="1"
                       show-file-name="true"
                       show-remarks="false"
                       enable-webcam="false"
                       validate='{pattern: ".csv,*.txt"}'>
          </file-upload>
        </td>
      </tr>
     </tbody>
      <tfoot ng-if="!\$ctrl.modificationMode && \$ctrl.inputMode === 'BATCH'">
      <tr>
        <td></td>
        <td></td>
        <td>
          <button
            type="button"
            class="btn btn-info"
            ng-click="\$ctrl.downloadSampleFile()">
            Download sample file
          </button>
          <button
            type="submit"
            class="btn btn-success"
            ng-disabled="!\$ctrl.simulateButtonEnabled()"
            ng-click="\$ctrl.simulate()">
            Simulate
          </button>
        </td>
      </tr>
      </tfoot>
    </table>

    <div class="alerts">
      <div class="alert" ng-show="createTransactionForm.\$invalid">
        Transaction is incomplete. Please fill out all fields.
      </div>
      <div class="alert alert--danger" ng-show="!\$ctrl.model.postingDateValid">
        Posting date must be a working day in transacting branch.
      </div>
      <div class="alert alert--danger" ng-show="!\$ctrl.isTransactionBalanced()">
        The transaction is not balanced.
      </div>
      <div class="alert alert--danger" ng-show="!\$ctrl.hasOperations()">
        There are no operations.
      </div>
      <div class="alert alert--danger" ng-show="!\$ctrl.hasNonZeroTotalAmounts()">
        At least one non-zero operation is needed for debit and credit.
      </div>
      <div class="alert" ng-show="\$ctrl.isFormValid()">
        The transaction is valid.
      </div>
    </div>

    <table class="table table--last-column-to-right transaction-create-table">
      <thead>
        <tr>
          <th class="no-column-header">No</th>
          <th colspan="2">Account</th>
          <th>Debit amount</th>
          <th>Credit amount</th>
          <th>Remarks</th>
          <th ng-if="\$ctrl.inputMode === 'MANUAL'">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="o in \$ctrl.model.operations">
          <td>{{\$index + 1}}.</td>
          <td colspan="2">
            <account-select ng-if="!\$ctrl.useCategories || \$ctrl.modificationMode"
                            options="\$ctrl.accountOptions"
                            ng-model="o.account"
                            value-field="'id'"
                            ng-required="true">
            </account-select>
            <account-select ng-if="\$ctrl.model.transactionType === 'NORMAL' && \$ctrl.useCategories && !\$ctrl.modificationMode"
                            options="\$ctrl.allAccounts"
                            ng-model="o.account"
                            value-field="'id'"
                            ng-required="true"
                            ng-disabled="true">
            </account-select>
          </td>
          <td>
            <cash ng-model="o.debitAmount"
              ng-disabled="o.creditAmount"
              ng-change="\$ctrl.resetCreditAmount(o)"
              ng-required="true"
              class="amount-input"></cash>
          </td>
          <td>
            <cash ng-model="o.creditAmount"
              ng-disabled="o.debitAmount"
              ng-change="\$ctrl.resetDebitAmount(o)"
              ng-required="true"></cash>
          </td>
          <td>
            <input type="text" ng-model-options="{updateOn: 'blur'}" ng-model="o.remarks"
                   ng-required="true" ng-change="\$ctrl.copyRemarks(o)"/>
          </td>
          <td ng-if="\$ctrl.actionButtonsEnabled()">
            <button type="button"
                    ng-click="\$ctrl.removeUnit(\$index)"
                    class="btn btn-danger">
              Remove
            </button>
          </td>
        </tr>
        <tr ng-if="\$ctrl.actionButtonsEnabled()">
          <td colspan="5">
          </td>
          <td>
            <button type="button"
                    ng-click="\$ctrl.addNewUnit()"
                    class="btn btn-primary">
              Add
            </button>
          </td>
        </tr>
      </tbody>
      <tfoot class="transaction-create-footer">
        <tr>
          <td colspan="2">
              <label class="total-label cursor-default pull-right">Total</label>
          </td>
          <td>
            <cash value="\$ctrl.calculateDebitSum().toFixed(2)"
              ng-disabled="true"></cash>
          </td>
          <td colspan="2" >
            <cash value="\$ctrl.calculateCreditSum().toFixed(2)"
              ng-disabled="true"></cash>
          </td>
          <td colspan="2"></td>
        </tr>
      </tfoot>
    </table>
    <div class="transaction-create-submit-buttons">
      <button type="button"
              class="btn btn-warning"
              ng-click="\$ctrl.cancelChanges()">
        Cancel
      </button>
      <button type="button"
              class="btn btn-primary"
              ng-click="\$ctrl.submit()"
              ng-disabled="!\$ctrl.isFormValid()">
        Save
      </button>
      <button type="button"
              class="btn btn-success"
              ng-click="\$ctrl.print()"
              ng-disabled="!\$ctrl.canPrint()">
        Print
      </button>
    </div>
  </form>
</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/general-ledger/transactions/gl-transaction-create.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;